import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/MaryNock/subs.vtt';
import poster from '@/static/assets/reviews/MaryNock/video.jpg';

export const MaryNock: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Home],
  reviewerName: 'Mary',
  videoUrl: `${ASSETS_URL}/home/MaryNock_Home.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
